import React from "react";
import { ErrorBoundary } from "../errorHandling/errorBoundary.jsx";
import { isMobile } from "react-device-detect";

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };

        this.iframeRef = React.createRef();
        this.onIframeLoad = this.onIframeLoad.bind(this);
    }

    //close the loading spinner and fire any custom onload event
    onIframeLoad() {
        document.getElementById("appModal").querySelector(".loader").classList.add("d-none");
        if (this.props.modalConfig.onModalLoaded) {
            this.props.modalConfig.onModalLoaded.call(this, this.iframeRef);
        }
    }

    handleClick() {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "modal", eventAction: "click", eventLabel: "close-modal" });
        this.props.onModalClose();
        const clickEvent = this.props.modalConfig.footerButtons?.Cancel?.onClick;
        if (clickEvent) {
            clickEvent();
        }
    }

    render() {
        const thisComponent = this;
        const iframeProps = {};
        if (thisComponent.props.modalConfig.content.iframeSrc !== undefined) {
            if (thisComponent.props.modalConfig.onModalLoad) {
                iframeProps.onLoad = thisComponent.props.onModalLoad;
            }
        }

        const modalDialogClass = this.props.modalConfig.modalDialogClass ? this.props.modalConfig.modalDialogClass : "";
        return (
            <ErrorBoundary componentName="Modal">
                <div className={"modal" + (isMobile ? " modal-mobile" : "") + this.props.modalConfig.extraClass} id="appModal">
                    <div className={"modal-dialog " + modalDialogClass}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{this.props.modalConfig.content.title}</h5>
                                {!this.props.modalConfig.removeCloseButton &&
                                    <button type="button" className="close" aria-label="Close" onClick={this.handleClick.bind(this)}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                }
                            </div>
                            <div className="modal-body">
                                {this.props.modalConfig.content.iframeSrc !== undefined &&
                                    <>
                                        <div className="loader">
                                            <div className="loader-overlay"></div>
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                        <iframe ref={this.iframeRef} data-hj-allow-iframe="" src={this.props.modalConfig.content.iframeSrc} frameBorder="0" {...iframeProps} onLoad={this.onIframeLoad} allow="camera;fullscreen" allowFullScreen />
                                    </>
                                }
                                {this.props.modalConfig.content.body !== undefined &&
                                    <div dangerouslySetInnerHTML={{ __html: this.props.modalConfig.content.body }}></div>
                                }
                                {this.props.modalConfig.content.markup !== undefined &&
                                    <>
                                        {this.props.modalConfig.content.markup}
                                    </>
                                }
                                {this.props.modalConfig.content.bodyObject}
                            </div>
                            {this.props.modalConfig.footerButtons &&
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.handleClick.bind(this)}>{this.props.modalConfig.footerButtons.Cancel.Text}</button>
                                    {this.props.modalConfig.footerButtons.Ok !== undefined &&
                                        <button type="button" className="btn btn-primary" onClick={this.props.modalConfig.footerButtons.Ok.onClick.bind(this)}>{this.props.modalConfig.footerButtons.Ok.Text}</button>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={"modal-backdrop show" + (isMobile ? " modal-backdrop-mobile" : "")}></div>
            </ErrorBoundary>
        );
    }
}

export { Modal };